document.addEventListener("DOMContentLoaded", function () {
  let seedStartingTableMobile;
  let seedStartingTableDesktop;

  function initSwipers() {
    if (seedStartingTableMobile) seedStartingTableMobile.destroy(true, true);
    if (seedStartingTableDesktop) seedStartingTableDesktop.destroy(true, true);

    seedStartingTableMobile = new Swiper(
      ".seed-starting-table__table-wrapper--mobile .seed-starting-table__table",
      {
        slidesPerView: columns,
        freeMode: true,
        scrollbar: {
          el: ".seed-starting-table__table-wrapper--mobile .swiper-scrollbar",
          draggable: true,
        },
      }
    );

    seedStartingTableDesktop = new Swiper(
      ".seed-starting-table__table-wrapper--desktop .seed-starting-table__table",
      {
        slidesPerView: columns_desktop,
        freeMode: true,
        spaceBetween: 15,
        scrollbar: {
          el: ".seed-starting-table__table-wrapper--desktop .swiper-scrollbar",
          draggable: true,
        },
      }
    );
  }

  function setEqualHeights() {
    // Process mobile and desktop wrappers separately
    const wrappers = document.querySelectorAll(".seed-starting-table__table-wrapper");
    
    wrappers.forEach((wrapper) => {
      // Skip hidden wrappers
      if (wrapper.offsetParent === null) return;

      const cellIndexes = new Set();

      wrapper
        .querySelectorAll(".seed-starting-table__cell[data-cell-index]")
        .forEach((cell) => {
          const index = cell.getAttribute("data-cell-index");
          cellIndexes.add(index);
        });

      cellIndexes.forEach((index) => {
        const cells = wrapper.querySelectorAll(
          `.seed-starting-table__cell[data-cell-index="${index}"]`
        );
        let maxHeight = 0;

        // Reset to auto so we measure natural height
        cells.forEach((cell) => (cell.style.minHeight = "auto"));

        // Measure the full height including padding
        cells.forEach((cell) => {
          const height = cell.offsetHeight;
          if (height > maxHeight) maxHeight = height;
        });

        // Use min-height so cells can grow if needed, but align at minimum
        cells.forEach((cell) => (cell.style.minHeight = `${maxHeight}px`));
      });
    });
  }

  function setEqualTitleHeights() {
    // Desktop titles
    const desktopTitles = document.querySelectorAll(
      ".seed-starting-table__product-title"
    );
    let maxDesktopHeight = 0;

    desktopTitles.forEach((title) => (title.style.height = "auto"));
    desktopTitles.forEach((title) => {
      const height = title.offsetHeight;
      if (height > maxDesktopHeight) maxDesktopHeight = height;
    });
    desktopTitles.forEach((title) => (title.style.height = `${maxDesktopHeight}px`));

    // Mobile titles (inside .container-title)
    const mobileTitles = document.querySelectorAll(
      ".seed-starting-table__table-wrapper--mobile .container-title p"
    );
    let maxMobileHeight = 0;

    mobileTitles.forEach((title) => (title.style.minHeight = "auto"));
    mobileTitles.forEach((title) => {
      const height = title.offsetHeight;
      if (height > maxMobileHeight) maxMobileHeight = height;
    });
    mobileTitles.forEach((title) => (title.style.minHeight = `${maxMobileHeight}px`));
  }

  function reloadSection() {
    initSwipers();
    setEqualHeights();
    setEqualTitleHeights();
  }

  // Call the functions initially on page load
  initSwipers();
  setEqualHeights();
  setEqualTitleHeights();

  // Recalculate heights when the window resizes
  window.addEventListener("resize", function () {
    setEqualHeights();
    setEqualTitleHeights();
  });

  // Shopify Theme Editor Events
  document.addEventListener("shopify:section:load", reloadSection);
  document.addEventListener("shopify:section:unload", reloadSection);
  document.addEventListener("shopify:section:select", reloadSection);
  document.addEventListener("shopify:section:deselect", reloadSection);
});
